/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useModal } from "../../../context/ModalContext";
import { useUserStore } from "../../../hooks/redux-hooks/user-store/user.store";
import { CloseIcon } from "../../../components/Icons";
import { StyledBookingFlowButton } from "../../containers/BookingScheduleContainer/BookingScheduleContainer.style";
import GvSecondaryButton from "../../../components/GvSecondaryButton/GvSecondaryButton";
import { AvatarCustom } from "../../../components";
import { useNavigate } from "react-router-dom";
import { MODALS } from "../../../config/params";
import { usePetStore } from "../../../hooks/redux-hooks/pet-store/pet-store.service";
import { useOverdueInvoiceStore } from "../../../hooks/redux-hooks/overdue-invoice-store/overdue-invoice.store";
import { IPetItemResponse } from "../../../services/pet-list/pet-list.interface";
import { PAGES_PATH } from "../../../navigation/params";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { userActivityLogger } from "../../../utils/mixpanel";

const PendingInvoiceAlertModal = () => {
  const { openModal, closeModal, retirePetId } = useModal();
  const { pendingPaymentPetList, cancelledWellnessPetList }=useOverdueInvoiceStore();
  const { petList } = usePetStore();
  const navigate = useNavigate();
  const [petData, setPetData] = useState<IPetItemResponse[]>();
  const isAlreadyOnBillingPage = window.location.href.includes(PAGES_PATH.USER_BILLING);

  const handlePayNowCta = () =>{
    if (pendingPaymentPetList.length > 1) {
      if (isAlreadyOnBillingPage) {
        closeModal();
      } else {
        navigate("/user-profile/payment");
        //  multiple pets pay now clicked
        pendingPaymentPetList.forEach((petData) => {
          userActivityLogger(MIXPANEL_EVENTS.PAY_NOW_CLICKED,
            {
              pet_name: petData.petName,
              referred_from_page: "retire_pet",
              due_amount: `${petData.dueAmount}`,
              invoice_due_date: petData.invoiceDueDate,
            });
        });
      }
    } else if (pendingPaymentPetList.length == 1) {
      userActivityLogger(MIXPANEL_EVENTS.PAY_NOW_CLICKED,
        {
          pet_name: pendingPaymentPetList[0].petName,
          referred_from_page: "retire_pet",
          due_amount: `${pendingPaymentPetList[0].dueAmount}`,
          invoice_due_date: pendingPaymentPetList[0].invoiceDueDate,
        });
      window.open(pendingPaymentPetList[0].publicUrl);
    };
  };


  const handleCta = () => {
    openModal(MODALS.OVERDUE_CONTACT_MODAL);
    userActivityLogger(MIXPANEL_EVENTS.CONTACT_HOSPITAL_TRIGGERED, {
      referred_from: "retire_pet",
    });
  };

  const handleModalClose = () =>{
    userActivityLogger(MIXPANEL_EVENTS.OVERDUE_POP_UP_CLOSED, {});
    closeModal();
  };

  useEffect(()=>{
    if (petList && (pendingPaymentPetList.length > 0)) {
      if (retirePetId) {
        setPetData( petList?.filter((petData) => petData.id === retirePetId));
      } else {
        setPetData( petList?.filter((petData) => petData.id === pendingPaymentPetList[0].petId));
      }
    }
  }, [pendingPaymentPetList, petList]);

  const isCancelledWellness = (id: string) => {
    const petDetails = pendingPaymentPetList.filter((petDetails: any) =>
      id === petDetails.petId);

    return petDetails.length > 0 && petDetails[0].pendingInvoices === 2;
  };

  return (
    <>
      {petData &&
        <div className="flex flex-col w-full xl:w-[27rem]">
          <div className="flex justify-end">
            <CloseIcon
              onClick={handleModalClose}
              className="text-light-black cursor-pointer"
            />
          </div>
          <div className="w-full flex flex-col items-center gap-4">
            <div>
              <AvatarCustom
                width={80}
                height={80}
                image={petData[0].image ? petData[0].image : ""}
                name={petData[0].name}
                isWellnessMember={cancelledWellnessPetList.filter((petDetails: any) =>
                  petData[0].id === petDetails.petId).length === 0}
                isPlanOverdue={cancelledWellnessPetList.filter((petDetails: any) =>
                  petData[0].id === petDetails.petId).length !== 0}
                isDashBoardPetCardBooking={{ wellnessIconCoordinates: { x: "50", y: "-25" },
                  wellnessIcon: { width: 26, height: 26 } }}
              />
            </div>
            <div className="text-xl font-semibold text-center w-80">
              {isCancelledWellness(petData[0].id) ? `${petData[0].name}'s 
              GoodPet+ Plan Has Been Canceled for Non-Payment` :
                `${petData[0].name}'s Wellness Plan
            payment is overdue.`}
            </div>
            <div className="flex flex-col gap-1.5 w-full">
              <div className="flex justify-center">
                <div className="text-center">
                  {`Please pay the outstanding balance on ${petData[0].name}'s wellness plan.
                  Without clearing this balance you will not be able to close your pet's profile.`}
                </div>
              </div>
              {!isCancelledWellness(petData[0].id) &&
              <StyledBookingFlowButton
                disabled={false}
                fullWidth
                color="primary"
                className="!text-sm"
                size="small"
                onClick={()=>handlePayNowCta()}
              >
                  Pay Now
              </StyledBookingFlowButton>}


              <div className="w-full">
                <GvSecondaryButton
                  type="button"
                  onClick={handleCta}
                  className="!w-full !font-semibold !border-1 !border-gray-4 hover:!bg-gray-3 !h-[2.5rem] !text-sm"
                >
                      Contact Hospital
                </GvSecondaryButton>
              </div>


            </div>
          </div>
        </div>}
    </>
  );
};

export default PendingInvoiceAlertModal;
